if (!customElements.get('ahead-gummies-rating')) {
  customElements.define('ahead-gummies-rating', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ratingLoaded === 'true' || this.loading) return;
      this.loading = true;
      const query = new URLSearchParams({ sku: this.dataset.reviewSkus, store: 'iheadnutrition.com', lang: 'de' });
      fetch('https://api.reviews.io/product/rating-batch?' + query)
        .then(response => {
          if (!response.ok) throw new Error('Bewertungen nicht verfügbar');
          return response.json();
        })
        .then(reviews => {
          if (!Array.isArray(reviews)) return;
          let total = 0;
          let weightedRating = 0;
          for (const review of reviews) {
            const count = Number(review.num_ratings);
            const score = Number(review.average_rating);
            if (!Number.isInteger(count) || count < 0 || !Number.isFinite(score) || score < 0 || score > 5) return;
            total += count;
            weightedRating += count * score;
          }
          if (total <= 0 || !this.isConnected) return;
          this.querySelector('[data-rating-value]').textContent = (weightedRating / total).toFixed(2).replace('.', ',');
          this.querySelector('.ag-rating__count').textContent = '· ' + total + ' Bewertungen';
          this.dataset.ratingLoaded = 'true';
          this.style.removeProperty('display');
        })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    }
  });
}
